<template>
  <vis-modal
    :title="$t('NewAccount')"
    :visible="modalShow"
    :toolbar="toolbar"
    :scrollable="!isFirstStep"
    @hide="hide"
    size="xl"
  >
    <b-modal
      :title="$t('validityReport')"
      class="modal-warning"
      v-model="validityReport.visible"
      @hide="validityReport.visible = false"
      hide-footer
    >
      <b-alert show variant="danger">{{ $t("validationErrors") }}</b-alert>
      <b-alert show variant="warning">
        <ul>
          <li v-for="(item, index) in validityReport.items" :key="index">
            <div class="my-1" v-if="item.messages">
              <div>{{ item.label }} :</div>
              <div
                class="ml-2"
                v-for="(message, index) in item.messages"
                :key="index"
              >
                - {{ message }}
              </div>
            </div>
            <div v-else>{{ item.label }} : {{ item.message }}</div>
          </li>
        </ul>
      </b-alert>
    </b-modal>

    <div
      v-for="(element, name) in schema" :key="name">
      <vis-editor-dv-element
        v-if="element.visible"
        :editor="element.editor"
        :component="element.component"
        :element="element.element"
        @checkValid="checkValid"
        @change="(e) => onChange(name, e)"
      />
    </div>

    <vis-confirm-dialog
      :visible="confirmDialog.visible"
      :title="confirmDialog.title"
      :text="confirmDialog.text"
      @acceptChanges="onAcceptConfirmDialog"
      @cancelChanges="closeConfirmDialog"
      @hideDialog="closeConfirmDialog"
    />

  </vis-modal>
</template>

<script>
import api from "@/api/visary-api";
import ModalShow from "@/mixins/modal-show";
import errorMessage from "@/shared/error-message";
import createAccountScheme from "@/views/admin/create-account-scheme";
import confirmDialog from '@/mixins/confirm-dialog';
import AccountCrudService from "@/shared/services/account-crud-service";

export default {
  name: "vis-create-account-form",
  mixins: [ ModalShow, confirmDialog ],
  props: {
    crudService: {
      type: Object,
      required: true
    }
  },
  data(vm) {
    return {
      schema: createAccountScheme(vm),
      isFirstStep: true,
      toolbar: [{
        id: "save-buttons",
        type: "button-group",
        position: "right",
        buttons: [
          {
            type: "button",
            text: "Next",
            variant: "success",
            onClick: vm.next,
            hidden: false
          },
          {
            type: "button",
            text: "Prev",
            variant: "warning",
            onClick: () => vm.isFirstStep = true,
            hidden: true
          },
          {
            type: "button",
            text: "Save",
            variant: "success",
            onClick: vm.save,
            hidden: true
          },
          {
            type: "button",
            text: "SaveAndClose",
            variant: "primary",
            onClick: vm.saveAndClose,
            hidden: true
          }
        ]
      }],
      validityReport: {
        visible: false,
        items: {},
      },
      updateAccountModel: {},
      account: null
    }
  },
  methods: {
    checkValid(e) {
      if (this.schema[e.sender.Name]) {
        let editor = this.schema[e.sender.Name]
        editor.valid = e.valid

        if (e.valid === false) {
          let message = e.errorMessage || this.$t("validationErrorMessages.requiredField")
          this.validityReport.items[e.sender.Name] = {
            label: editor.element.Text,
            message,
          };
        } else {
          if (Object.hasOwnProperty.call(this.validityReport.items, e.sender.Name)) {
            delete this.validityReport.items[e.sender.Name];
          }
        }
      }
    },
    async save() {
      if (this.hasErrors()) {
        this.validityReport.visible = true;
        return;
      }
      if (!this.account) {
        let authModel = {
          Email: this.schema.Email.editor.value,
          Password: this.schema.Password.editor.value,
        }
        try {
          this.account = await new AccountCrudService().save(authModel)
          this.crudService.setId(this.account.ID)
          await this.crudService.get()
        } catch(err) {
          this.showErrorMessage(err)
        }
      }
      await this.updateAccount()
    },
    async saveAndClose() {
      await this.save()
      this.hide()
    },
    async updateAccount() {
      const promices = []
      Object.keys(this.updateAccountModel).forEach(mnemonic => {
        if (this.updateAccountModel[mnemonic]) {
          this.updateAccountModel[mnemonic].ID = this.account.ID
          promices.push(
            api.crud.update(
              mnemonic,
              this.account.ID,
              this.updateAccountModel[mnemonic],
              false
            )
          )
        }
      })
      if (promices.length) {
        try {
          await Promise.all(promices)
          this.$visNotification.success(this.$t("detailView.notifications.saved"));
        } catch(err) {
          this.showErrorMessage(err)
        }
      } else {
        this.$visNotification.info(this.$t("detailView.notifications.dataNotChanged"));
      }
      this.updateAccountModel = {}
      this.dirty = false
    },
    next() {
      if (this.hasErrors()) {
        this.validityReport.visible = true;
        return;
      } else {
        this.isFirstStep = false
      }
    },
    hasErrors() {
      return Object.keys(this.validityReport.items).length !== 0
    },
    hide(e) {
      if (this.dirty) {
        e.preventDefault()
        return this.openConfirmDialog(this.confirmDialogs.unsavedChanges);
      }
      this.$emit('hide');
    },
    onChange(field, e) {
      this.schema[field].editor.value = e.value;
      this.dirty = true
      let mnemonic = this.schema[field].mnemonic
      if (!mnemonic) return
      this.updateAccountModel[mnemonic] = this.updateAccountModel[mnemonic] || {}
      this.updateAccountModel[mnemonic][field] = e.value
    },
    async showErrorMessage(err) {
      let error = await errorMessage(err);
      this.$visNotification.show(error.title, error.message, "danger");
    }
  },
  watch: {
    isFirstStep(val) {
      this.validityReport.items = {}

      Object.keys(this.schema).forEach(element => {
        this.schema[element].visible = !this.schema[element].visible
      })
      this.toolbar[0].buttons.forEach(button => {
        button.hidden = !button.hidden
      })
    }
  },
}
</script>
